import type { Ref } from 'vue'
import { onMounted, onUnmounted } from 'vue'

type UseClickOutsideEntry = {
    ref: Ref<HTMLElement | null>
    callback: (event: Event) => void
}

const activeEntries: UseClickOutsideEntry[] = []

const handleDocumentClick = (event: Event) => {
    activeEntries.forEach(({ ref, callback }) => {
        if (ref.value && !ref.value.contains(event.target as Node)) {
            callback(event)
        }
    })
}

const manageGlobalListener = (() => {
    let isListening = false

    return () => {
        if (activeEntries.length > 0 && !isListening) {
            document.addEventListener('click', handleDocumentClick)
            document.addEventListener('touchstart', handleDocumentClick)
            isListening = true
        }

        if (activeEntries.length === 0 && isListening) {
            document.removeEventListener('click', handleDocumentClick)
            document.removeEventListener('touchstart', handleDocumentClick)
            isListening = false
        }
    }
})()

export default function useClickOutside(targetRef: Ref<HTMLElement | null>, callback: (event: Event) => void) {
    onMounted(() => {
        activeEntries.push({ ref: targetRef, callback })
        manageGlobalListener()
    })

    onUnmounted(() => {
        const index = activeEntries.findIndex((entry) => entry.ref === targetRef)
        if (index !== -1) activeEntries.splice(index, 1)
        manageGlobalListener()
    })

    return {
        targetRef,
    }
}
